import { Position } from '../../types'
import { useContext, useMemo } from 'react'
import { CutterContext } from '../contexts/CutterContext'
import { getVisiblePositionPercent } from '../functions/getVisiblePositionPercent'

export function useVisiblePositionPercent(position: Position): number {
  const { visibleRange } = useContext(CutterContext)

  return useMemo(() => getVisiblePositionPercent(position, visibleRange), [position, visibleRange])
}
